<template>
  <div class="row" style="margin-top: 70px">
    <dashboard-header style="width: 100%; margin-left: "></dashboard-header>
    <div class="col-md-12">
      <div class="card card-stats card-raised">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon" style="color: #2ca8ff;">
                    <i class="jipvio-ui-icons-users"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="20"></animated-number>
                    <small>명</small>
                  </h3>
                  <h6 class="stats-title">신규 가입자수</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-success">
                    <i class="el-icon-office-building"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="2"></animated-number>
                    <small>개</small>
                  </h3>
                  <h6 class="stats-title">신규 매물의뢰</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-info">
                    <i class="el-icon-chat-dot-round"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="10"></animated-number>
                    <small>건</small>
                  </h3>
                  <h6 class="stats-title">신규 문의건수</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-danger">
                    <i class="fas fa-history"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="24"></animated-number>
                    <small>건</small>
                  </h3>
                  <h6 class="stats-title">매물노출건수</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card card-stats card-raised">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon" style="color: #2ca8ff;">
                    <i class="jipvio-ui-icons-users"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="30"></animated-number>
                    <small>명</small>
                  </h3>
                  <h6 class="stats-title">신규 가입자수</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-success">
                    <i class="el-icon-chat-dot-round"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="10"></animated-number>
                    <small>건</small>
                  </h3>
                  <h6 class="stats-title">신규 문의건수</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card card-stats card-raised">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon" style="color: #2ca8ff;">
                    <i class="jipvio-ui-icons-users"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="24"></animated-number>
                    <small>명</small>
                  </h3>
                  <h6 class="stats-title">신규 가입자수</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-success">
                    <i class="el-icon-office-building"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="20"></animated-number>
                    <small>건</small>
                  </h3>
                  <h6 class="stats-title">신규 매물등록 요청</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-info">
                    <i class="el-icon-chat-dot-round"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="10"></animated-number>
                    <small>건</small>
                  </h3>
                  <h6 class="stats-title">신규 문의건수</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-danger">
                    <i class="fas fa-history"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="20"></animated-number>
                    <small>건</small>
                  </h3>
                  <h6 class="stats-title">매물노출건수</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import card from "@/components/Cards/Card.vue";
import AnimatedNumber from "@/components/AnimatedNumber.vue";
import DashboardHeader from "@/pages/Dashboard/DashboardHeader.vue";

export default {
  components: {
    card,
    AnimatedNumber,
    DashboardHeader
  },

  created() {},

  computed: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
<style>
/* canvas#line-chart {
  width: 90% !important;
  margin: auto;
} */
</style>
